import { TAppThunkDispatch, TGetState } from '~/src/store';

import { fillPaymentSum, removePaymentQrCode, setPaymentResult } from '../actionCreators';

const setPaymentSum = (sum: number) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const { payment: { sbpData: { qrCode, qrLink }, result, paymentData: { isUseBonuses } } } = getState();

        if (qrCode || qrLink) {
            dispatch(removePaymentQrCode());
        }

        if (isUseBonuses && result.isBonusesSuccess) {
            dispatch(setPaymentResult({ ...result, isBonusesSuccess: false }));
        }

        dispatch(fillPaymentSum(sum));
    };
};

export default setPaymentSum;
